import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("menu.config.settings"))),
      ]),
      _c("actions-component"),
      _c(
        VCard,
        [
          _c(
            VCardText,
            [
              _c(
                VRow,
                { attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("API Gateway")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          readonly: !_vm.edit,
                          dense: "",
                          outlined: "",
                          rules: [
                            function (v) {
                              return !!v || "Is required"
                            },
                          ],
                          filled: !_vm.edit,
                        },
                        model: {
                          value: _vm.config.api_gateway_url,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "api_gateway_url", $$v)
                          },
                          expression: "config.api_gateway_url",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("Verificación de Backup Auditoria")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _vm.config.audit_buckup_verify
                        ? _c(VCombobox, {
                            attrs: {
                              multiple: "",
                              dense: "",
                              outlined: "",
                              chips: "",
                              "append-icon": "",
                              disabled: !_vm.edit,
                              filled: !_vm.edit,
                            },
                            on: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "space",
                                    32,
                                    $event.key,
                                    [" ", "Spacebar"]
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "selection",
                                  fn: function (ref) {
                                    var item = ref.item
                                    var attrs = ref.attrs
                                    var selected = ref.selected
                                    var disabled = ref.disabled
                                    var parent = ref.parent
                                    return [
                                      _c(
                                        VChip,
                                        _vm._b(
                                          {
                                            key: JSON.stringify(item),
                                            attrs: {
                                              "input-value": selected,
                                              disabled: !_vm.edit,
                                              dark: "",
                                            },
                                            on: {
                                              "click:close": function ($event) {
                                                return parent.selectItem(item)
                                              },
                                            },
                                          },
                                          "v-chip",
                                          attrs,
                                          false
                                        ),
                                        [_vm._v(_vm._s(item))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3296037812
                            ),
                            model: {
                              value: _vm.config.audit_buckup_verify,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "audit_buckup_verify", $$v)
                              },
                              expression: "config.audit_buckup_verify",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("Tamaño de Búsqueda Batch")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          readonly: !_vm.edit,
                          dense: "",
                          outlined: "",
                          rules: [
                            function (v) {
                              return !!v || "Is required"
                            },
                          ],
                          filled: !_vm.edit,
                          type: "number",
                        },
                        model: {
                          value: _vm.config.batch_size_search,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "batch_size_search", $$v)
                          },
                          expression: "config.batch_size_search",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("API Notificación")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          readonly: !_vm.edit,
                          dense: "",
                          outlined: "",
                          rules: [
                            function (v) {
                              return !!v || "Is required"
                            },
                          ],
                          filled: !_vm.edit,
                        },
                        model: {
                          value: _vm.config.cr_mail_notification,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "cr_mail_notification", $$v)
                          },
                          expression: "config.cr_mail_notification",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("API Scan Power BI")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          readonly: !_vm.edit,
                          dense: "",
                          outlined: "",
                          rules: [
                            function (v) {
                              return !!v || "Is required"
                            },
                          ],
                          filled: !_vm.edit,
                        },
                        model: {
                          value: _vm.config.cr_powerbi_scan,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "cr_powerbi_scan", $$v)
                          },
                          expression: "config.cr_powerbi_scan",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("API Data Quality")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          readonly: !_vm.edit,
                          dense: "",
                          outlined: "",
                          rules: [
                            function (v) {
                              return !!v || "Is required"
                            },
                          ],
                          filled: !_vm.edit,
                        },
                        model: {
                          value: _vm.config.cr_quality_url,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "cr_quality_url", $$v)
                          },
                          expression: "config.cr_quality_url",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("API Tablas y Vistas")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          readonly: !_vm.edit,
                          dense: "",
                          outlined: "",
                          rules: [
                            function (v) {
                              return !!v || "Is required"
                            },
                          ],
                          filled: !_vm.edit,
                        },
                        model: {
                          value: _vm.config.cr_tables_views,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "cr_tables_views", $$v)
                          },
                          expression: "config.cr_tables_views",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("API Work Enviroments")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          readonly: !_vm.edit,
                          dense: "",
                          outlined: "",
                          rules: [
                            function (v) {
                              return !!v || "Is required"
                            },
                          ],
                          filled: !_vm.edit,
                        },
                        model: {
                          value: _vm.config.cr_work_environments_url,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.config,
                              "cr_work_environments_url",
                              $$v
                            )
                          },
                          expression: "config.cr_work_environments_url",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("Directorio Centro de Ayuda")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _vm.config.directory
                        ? _c(VTextField, {
                            attrs: {
                              readonly: !_vm.edit,
                              dense: "",
                              outlined: "",
                              rules: [
                                function (v) {
                                  return !!v || "Is required"
                                },
                              ],
                              filled: !_vm.edit,
                            },
                            model: {
                              value: _vm.config.directory.help_center,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.config.directory,
                                  "help_center",
                                  $$v
                                )
                              },
                              expression: "config.directory.help_center",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("Reporte Resumen Data Quality")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          readonly: !_vm.edit,
                          dense: "",
                          outlined: "",
                          rules: [
                            function (v) {
                              return !!v || "Is required"
                            },
                          ],
                          filled: !_vm.edit,
                        },
                        model: {
                          value: _vm.config.dq_profiling_summary_details_url,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.config,
                              "dq_profiling_summary_details_url",
                              $$v
                            )
                          },
                          expression: "config.dq_profiling_summary_details_url",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("Errores al Crear Vista de Acceso")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _vm.config.erros_access_view_created
                        ? _c(VCombobox, {
                            attrs: {
                              multiple: "",
                              dense: "",
                              outlined: "",
                              chips: "",
                              "append-icon": "",
                              disabled: !_vm.edit,
                              filled: !_vm.edit,
                            },
                            on: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "space",
                                    32,
                                    $event.key,
                                    [" ", "Spacebar"]
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "selection",
                                  fn: function (ref) {
                                    var item = ref.item
                                    var attrs = ref.attrs
                                    var selected = ref.selected
                                    var disabled = ref.disabled
                                    var parent = ref.parent
                                    return [
                                      _c(
                                        VChip,
                                        _vm._b(
                                          {
                                            key: JSON.stringify(item),
                                            attrs: {
                                              "input-value": selected,
                                              disabled: !_vm.edit,
                                              dark: "",
                                            },
                                            on: {
                                              "click:close": function ($event) {
                                                return parent.selectItem(item)
                                              },
                                            },
                                          },
                                          "v-chip",
                                          attrs,
                                          false
                                        ),
                                        [_vm._v(_vm._s(item))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3296037812
                            ),
                            model: {
                              value: _vm.config.erros_access_view_created,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.config,
                                  "erros_access_view_created",
                                  $$v
                                )
                              },
                              expression: "config.erros_access_view_created",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("Tiempo de Expiración")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          readonly: !_vm.edit,
                          dense: "",
                          outlined: "",
                          rules: [
                            function (v) {
                              return !!v || "Is required"
                            },
                          ],
                          filled: !_vm.edit,
                          type: "number",
                        },
                        model: {
                          value: _vm.config.expiration_time,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "expiration_time", $$v)
                          },
                          expression: "config.expiration_time",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("Empresas Impersonalizadas")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _vm.config.impersonated_org
                        ? _c(VCombobox, {
                            attrs: {
                              multiple: "",
                              dense: "",
                              outlined: "",
                              chips: "",
                              "append-icon": "",
                              disabled: !_vm.edit,
                              filled: !_vm.edit,
                            },
                            on: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "space",
                                    32,
                                    $event.key,
                                    [" ", "Spacebar"]
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "selection",
                                  fn: function (ref) {
                                    var item = ref.item
                                    var attrs = ref.attrs
                                    var selected = ref.selected
                                    var disabled = ref.disabled
                                    var parent = ref.parent
                                    return [
                                      _c(
                                        VChip,
                                        _vm._b(
                                          {
                                            key: JSON.stringify(item),
                                            attrs: {
                                              "input-value": selected,
                                              disabled: !_vm.edit,
                                              dark: "",
                                            },
                                            on: {
                                              "click:close": function ($event) {
                                                return parent.selectItem(item)
                                              },
                                            },
                                          },
                                          "v-chip",
                                          attrs,
                                          false
                                        ),
                                        [_vm._v(_vm._s(item))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3296037812
                            ),
                            model: {
                              value: _vm.config.impersonated_org,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "impersonated_org", $$v)
                              },
                              expression: "config.impersonated_org",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("Host INCA")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          readonly: !_vm.edit,
                          dense: "",
                          outlined: "",
                          rules: [
                            function (v) {
                              return !!v || "Is required"
                            },
                          ],
                          filled: !_vm.edit,
                        },
                        model: {
                          value: _vm.config.inca_base_url,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "inca_base_url", $$v)
                          },
                          expression: "config.inca_base_url",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("Lista de Zonas")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _vm.config.list_zones
                        ? _c(VCombobox, {
                            attrs: {
                              multiple: "",
                              dense: "",
                              outlined: "",
                              chips: "",
                              "append-icon": "",
                              disabled: !_vm.edit,
                              filled: !_vm.edit,
                            },
                            on: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "space",
                                    32,
                                    $event.key,
                                    [" ", "Spacebar"]
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "selection",
                                  fn: function (ref) {
                                    var item = ref.item
                                    var attrs = ref.attrs
                                    var selected = ref.selected
                                    var disabled = ref.disabled
                                    var parent = ref.parent
                                    return [
                                      _c(
                                        VChip,
                                        _vm._b(
                                          {
                                            key: JSON.stringify(item),
                                            attrs: {
                                              "input-value": selected,
                                              disabled: !_vm.edit,
                                              dark: "",
                                            },
                                            on: {
                                              "click:close": function ($event) {
                                                return parent.selectItem(item)
                                              },
                                            },
                                          },
                                          "v-chip",
                                          attrs,
                                          false
                                        ),
                                        [_vm._v(_vm._s(item))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3296037812
                            ),
                            model: {
                              value: _vm.config.list_zones,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "list_zones", $$v)
                              },
                              expression: "config.list_zones",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("Nro Máximo de Columnas en Vista")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          readonly: !_vm.edit,
                          dense: "",
                          outlined: "",
                          rules: [
                            function (v) {
                              return !!v || "Is required"
                            },
                          ],
                          filled: !_vm.edit,
                          type: "number",
                        },
                        model: {
                          value: _vm.config.max_columns_view,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "max_columns_view", $$v)
                          },
                          expression: "config.max_columns_view",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("SA Atributos")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          readonly: !_vm.edit,
                          dense: "",
                          outlined: "",
                          rules: [
                            function (v) {
                              return !!v || "Is required"
                            },
                          ],
                          filled: !_vm.edit,
                        },
                        model: {
                          value: _vm.config.sa_attributes,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "sa_attributes", $$v)
                          },
                          expression: "config.sa_attributes",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("SA Audiencias")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          readonly: !_vm.edit,
                          dense: "",
                          outlined: "",
                          rules: [
                            function (v) {
                              return !!v || "Is required"
                            },
                          ],
                          filled: !_vm.edit,
                        },
                        model: {
                          value: _vm.config.sa_audiences,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "sa_audiences", $$v)
                          },
                          expression: "config.sa_audiences",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("SA Productivizar")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          readonly: !_vm.edit,
                          dense: "",
                          outlined: "",
                          rules: [
                            function (v) {
                              return !!v || "Is required"
                            },
                          ],
                          filled: !_vm.edit,
                        },
                        model: {
                          value: _vm.config.sa_productivize,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "sa_productivize", $$v)
                          },
                          expression: "config.sa_productivize",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("Reporte Audiencias Monetización")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          readonly: !_vm.edit,
                          dense: "",
                          outlined: "",
                          rules: [
                            function (v) {
                              return !!v || "Is required"
                            },
                          ],
                          filled: !_vm.edit,
                        },
                        model: {
                          value: _vm.config.url_analytics_audience_monetization,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.config,
                              "url_analytics_audience_monetization",
                              $$v
                            )
                          },
                          expression:
                            "config.url_analytics_audience_monetization",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("Reporte Audiencias Omnicanal")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          readonly: !_vm.edit,
                          dense: "",
                          outlined: "",
                          rules: [
                            function (v) {
                              return !!v || "Is required"
                            },
                          ],
                          filled: !_vm.edit,
                        },
                        model: {
                          value: _vm.config.url_analytics_audience_omnicanal,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.config,
                              "url_analytics_audience_omnicanal",
                              $$v
                            )
                          },
                          expression: "config.url_analytics_audience_omnicanal",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("Reporte Audiencias Performance")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          readonly: !_vm.edit,
                          dense: "",
                          outlined: "",
                          rules: [
                            function (v) {
                              return !!v || "Is required"
                            },
                          ],
                          filled: !_vm.edit,
                        },
                        model: {
                          value: _vm.config.url_analytics_audience_performance,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.config,
                              "url_analytics_audience_performance",
                              $$v
                            )
                          },
                          expression:
                            "config.url_analytics_audience_performance",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("Reporte Audiencias Share")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          readonly: !_vm.edit,
                          dense: "",
                          outlined: "",
                          rules: [
                            function (v) {
                              return !!v || "Is required"
                            },
                          ],
                          filled: !_vm.edit,
                        },
                        model: {
                          value: _vm.config.url_analytics_audience_share,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.config,
                              "url_analytics_audience_share",
                              $$v
                            )
                          },
                          expression: "config.url_analytics_audience_share",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("API MLOps")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          readonly: !_vm.edit,
                          dense: "",
                          outlined: "",
                          rules: [
                            function (v) {
                              return !!v || "Is required"
                            },
                          ],
                          filled: !_vm.edit,
                        },
                        model: {
                          value: _vm.config.url_api_mlops_framework,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "url_api_mlops_framework", $$v)
                          },
                          expression: "config.url_api_mlops_framework",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s("Reporte Metricas INCA")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          readonly: !_vm.edit,
                          dense: "",
                          outlined: "",
                          rules: [
                            function (v) {
                              return !!v || "Is required"
                            },
                          ],
                          filled: !_vm.edit,
                        },
                        model: {
                          value: _vm.config.url_inca_metrics,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "url_inca_metrics", $$v)
                          },
                          expression: "config.url_inca_metrics",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(VCol, { attrs: { cols: "12" } }, [
                    _c(
                      "fieldset",
                      { staticClass: "fieldset" },
                      [
                        _c("legend", [
                          _vm._v(_vm._s("Reporte de acciones: Atributos")),
                        ]),
                        _c(
                          VRow,
                          { attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v(_vm._s("URL"))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _vm.config.use_inca_actions
                                  ? _c(VTextField, {
                                      attrs: {
                                        readonly: !_vm.edit,
                                        dense: "",
                                        outlined: "",
                                        rules: [
                                          function (v) {
                                            return !!v || "Is required"
                                          },
                                        ],
                                        filled: !_vm.edit,
                                      },
                                      model: {
                                        value:
                                          _vm.config.use_inca_actions.attributes
                                            .url,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.config.use_inca_actions
                                              .attributes,
                                            "url",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "config.use_inca_actions.attributes.url",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v(_vm._s("Mulitorg"))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _vm.config.use_inca_actions
                                  ? _c(VCheckbox, {
                                      attrs: {
                                        readonly: !_vm.edit,
                                        disabled: !_vm.edit,
                                        dense: "",
                                        outlined: "",
                                        rules: [
                                          function (v) {
                                            return !!v || "Is required"
                                          },
                                        ],
                                        filled: !_vm.edit,
                                      },
                                      model: {
                                        value:
                                          _vm.config.use_inca_actions.attributes
                                            .multiorg,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.config.use_inca_actions
                                              .attributes,
                                            "multiorg",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "config.use_inca_actions.attributes.multiorg",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v(_vm._s("LLaves"))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _vm.config.use_inca_actions
                                  ? _c(VCombobox, {
                                      attrs: {
                                        multiple: "",
                                        dense: "",
                                        outlined: "",
                                        chips: "",
                                        "append-icon": "",
                                        disabled: !_vm.edit,
                                        filled: !_vm.edit,
                                      },
                                      on: {
                                        keydown: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "space",
                                              32,
                                              $event.key,
                                              [" ", "Spacebar"]
                                            )
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "selection",
                                            fn: function (ref) {
                                              var item = ref.item
                                              var attrs = ref.attrs
                                              var selected = ref.selected
                                              var disabled = ref.disabled
                                              var parent = ref.parent
                                              return [
                                                _c(
                                                  VChip,
                                                  _vm._b(
                                                    {
                                                      key: JSON.stringify(item),
                                                      attrs: {
                                                        "input-value": selected,
                                                        disabled: !_vm.edit,
                                                        dark: "",
                                                      },
                                                      on: {
                                                        "click:close":
                                                          function ($event) {
                                                            return parent.selectItem(
                                                              item
                                                            )
                                                          },
                                                      },
                                                    },
                                                    "v-chip",
                                                    attrs,
                                                    false
                                                  ),
                                                  [_vm._v(_vm._s(item))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3296037812
                                      ),
                                      model: {
                                        value:
                                          _vm.config.use_inca_actions.attributes
                                            .keys,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.config.use_inca_actions
                                              .attributes,
                                            "keys",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "config.use_inca_actions.attributes.keys",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(VCol, { attrs: { cols: "12" } }, [
                    _c(
                      "fieldset",
                      { staticClass: "fieldset" },
                      [
                        _c("legend", [
                          _vm._v(_vm._s("Reporte de acciones: Audiencias")),
                        ]),
                        _c(
                          VRow,
                          { attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v(_vm._s("URL"))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _vm.config.use_inca_actions
                                  ? _c(VTextField, {
                                      attrs: {
                                        readonly: !_vm.edit,
                                        dense: "",
                                        outlined: "",
                                        rules: [
                                          function (v) {
                                            return !!v || "Is required"
                                          },
                                        ],
                                        filled: !_vm.edit,
                                      },
                                      model: {
                                        value:
                                          _vm.config.use_inca_actions.audiences
                                            .url,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.config.use_inca_actions
                                              .audiences,
                                            "url",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "config.use_inca_actions.audiences.url",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v(_vm._s("Mulitorg"))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _vm.config.use_inca_actions
                                  ? _c(VCheckbox, {
                                      attrs: {
                                        readonly: !_vm.edit,
                                        disabled: !_vm.edit,
                                        dense: "",
                                        outlined: "",
                                        rules: [
                                          function (v) {
                                            return !!v || "Is required"
                                          },
                                        ],
                                        filled: !_vm.edit,
                                      },
                                      model: {
                                        value:
                                          _vm.config.use_inca_actions.audiences
                                            .multiorg,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.config.use_inca_actions
                                              .audiences,
                                            "multiorg",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "config.use_inca_actions.audiences.multiorg",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v(_vm._s("LLaves"))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _vm.config.use_inca_actions
                                  ? _c(VCombobox, {
                                      attrs: {
                                        multiple: "",
                                        dense: "",
                                        outlined: "",
                                        chips: "",
                                        "append-icon": "",
                                        disabled: !_vm.edit,
                                        filled: !_vm.edit,
                                      },
                                      on: {
                                        keydown: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "space",
                                              32,
                                              $event.key,
                                              [" ", "Spacebar"]
                                            )
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "selection",
                                            fn: function (ref) {
                                              var item = ref.item
                                              var attrs = ref.attrs
                                              var selected = ref.selected
                                              var disabled = ref.disabled
                                              var parent = ref.parent
                                              return [
                                                _c(
                                                  VChip,
                                                  _vm._b(
                                                    {
                                                      key: JSON.stringify(item),
                                                      attrs: {
                                                        "input-value": selected,
                                                        disabled: !_vm.edit,
                                                        dark: "",
                                                      },
                                                      on: {
                                                        "click:close":
                                                          function ($event) {
                                                            return parent.selectItem(
                                                              item
                                                            )
                                                          },
                                                      },
                                                    },
                                                    "v-chip",
                                                    attrs,
                                                    false
                                                  ),
                                                  [_vm._v(_vm._s(item))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3296037812
                                      ),
                                      model: {
                                        value:
                                          _vm.config.use_inca_actions.audiences
                                            .keys,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.config.use_inca_actions
                                              .audiences,
                                            "keys",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "config.use_inca_actions.audiences.keys",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(VCol, { attrs: { cols: "12" } }, [
                    _c(
                      "fieldset",
                      { staticClass: "fieldset" },
                      [
                        _c("legend", [
                          _vm._v(
                            _vm._s("Reporte de acciones: Gestión de Datos")
                          ),
                        ]),
                        _c(
                          VRow,
                          { attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v(_vm._s("URL"))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _vm.config.use_inca_actions
                                  ? _c(VTextField, {
                                      attrs: {
                                        readonly: !_vm.edit,
                                        dense: "",
                                        outlined: "",
                                        rules: [
                                          function (v) {
                                            return !!v || "Is required"
                                          },
                                        ],
                                        filled: !_vm.edit,
                                      },
                                      model: {
                                        value:
                                          _vm.config.use_inca_actions
                                            .data_management.url,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.config.use_inca_actions
                                              .data_management,
                                            "url",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "config.use_inca_actions.data_management.url",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v(_vm._s("Mulitorg"))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _vm.config.use_inca_actions
                                  ? _c(VCheckbox, {
                                      attrs: {
                                        readonly: !_vm.edit,
                                        disabled: !_vm.edit,
                                        dense: "",
                                        outlined: "",
                                        rules: [
                                          function (v) {
                                            return !!v || "Is required"
                                          },
                                        ],
                                        filled: !_vm.edit,
                                      },
                                      model: {
                                        value:
                                          _vm.config.use_inca_actions
                                            .data_management.multiorg,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.config.use_inca_actions
                                              .data_management,
                                            "multiorg",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "config.use_inca_actions.data_management.multiorg",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v(_vm._s("LLaves"))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _vm.config.use_inca_actions
                                  ? _c(VCombobox, {
                                      attrs: {
                                        multiple: "",
                                        dense: "",
                                        outlined: "",
                                        chips: "",
                                        "append-icon": "",
                                        disabled: !_vm.edit,
                                        filled: !_vm.edit,
                                      },
                                      on: {
                                        keydown: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "space",
                                              32,
                                              $event.key,
                                              [" ", "Spacebar"]
                                            )
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "selection",
                                            fn: function (ref) {
                                              var item = ref.item
                                              var attrs = ref.attrs
                                              var selected = ref.selected
                                              var disabled = ref.disabled
                                              var parent = ref.parent
                                              return [
                                                _c(
                                                  VChip,
                                                  _vm._b(
                                                    {
                                                      key: JSON.stringify(item),
                                                      attrs: {
                                                        "input-value": selected,
                                                        disabled: !_vm.edit,
                                                        dark: "",
                                                      },
                                                      on: {
                                                        "click:close":
                                                          function ($event) {
                                                            return parent.selectItem(
                                                              item
                                                            )
                                                          },
                                                      },
                                                    },
                                                    "v-chip",
                                                    attrs,
                                                    false
                                                  ),
                                                  [_vm._v(_vm._s(item))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3296037812
                                      ),
                                      model: {
                                        value:
                                          _vm.config.use_inca_actions
                                            .data_management.keys,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.config.use_inca_actions
                                              .data_management,
                                            "keys",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "config.use_inca_actions.data_management.keys",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(VCol, { attrs: { cols: "12" } }, [
                    _c(
                      "fieldset",
                      { staticClass: "fieldset" },
                      [
                        _c("legend", [
                          _vm._v(_vm._s("Reporte de acciones: Insights")),
                        ]),
                        _c(
                          VRow,
                          { attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v(_vm._s("URL"))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _vm.config.use_inca_actions
                                  ? _c(VTextField, {
                                      attrs: {
                                        readonly: !_vm.edit,
                                        dense: "",
                                        outlined: "",
                                        rules: [
                                          function (v) {
                                            return !!v || "Is required"
                                          },
                                        ],
                                        filled: !_vm.edit,
                                      },
                                      model: {
                                        value:
                                          _vm.config.use_inca_actions.insights
                                            .url,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.config.use_inca_actions
                                              .insights,
                                            "url",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "config.use_inca_actions.insights.url",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v(_vm._s("Mulitorg"))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _vm.config.use_inca_actions
                                  ? _c(VCheckbox, {
                                      attrs: {
                                        readonly: !_vm.edit,
                                        disabled: !_vm.edit,
                                        dense: "",
                                        outlined: "",
                                        rules: [
                                          function (v) {
                                            return !!v || "Is required"
                                          },
                                        ],
                                        filled: !_vm.edit,
                                      },
                                      model: {
                                        value:
                                          _vm.config.use_inca_actions.insights
                                            .multiorg,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.config.use_inca_actions
                                              .insights,
                                            "multiorg",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "config.use_inca_actions.insights.multiorg",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v(_vm._s("LLaves"))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _vm.config.use_inca_actions
                                  ? _c(VCombobox, {
                                      attrs: {
                                        multiple: "",
                                        dense: "",
                                        outlined: "",
                                        chips: "",
                                        "append-icon": "",
                                        disabled: !_vm.edit,
                                        filled: !_vm.edit,
                                      },
                                      on: {
                                        keydown: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "space",
                                              32,
                                              $event.key,
                                              [" ", "Spacebar"]
                                            )
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "selection",
                                            fn: function (ref) {
                                              var item = ref.item
                                              var attrs = ref.attrs
                                              var selected = ref.selected
                                              var disabled = ref.disabled
                                              var parent = ref.parent
                                              return [
                                                _c(
                                                  VChip,
                                                  _vm._b(
                                                    {
                                                      key: JSON.stringify(item),
                                                      attrs: {
                                                        "input-value": selected,
                                                        disabled: !_vm.edit,
                                                        dark: "",
                                                      },
                                                      on: {
                                                        "click:close":
                                                          function ($event) {
                                                            return parent.selectItem(
                                                              item
                                                            )
                                                          },
                                                      },
                                                    },
                                                    "v-chip",
                                                    attrs,
                                                    false
                                                  ),
                                                  [_vm._v(_vm._s(item))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3296037812
                                      ),
                                      model: {
                                        value:
                                          _vm.config.use_inca_actions.insights
                                            .keys,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.config.use_inca_actions
                                              .insights,
                                            "keys",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "config.use_inca_actions.insights.keys",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(VCol, { attrs: { cols: "12" } }, [
                    _c(
                      "fieldset",
                      { staticClass: "fieldset" },
                      [
                        _c("legend", [
                          _vm._v(_vm._s("Reporte de acciones: MLOps")),
                        ]),
                        _c(
                          VRow,
                          { attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v(_vm._s("URL"))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _vm.config.use_inca_actions
                                  ? _c(VTextField, {
                                      attrs: {
                                        readonly: !_vm.edit,
                                        dense: "",
                                        outlined: "",
                                        rules: [
                                          function (v) {
                                            return !!v || "Is required"
                                          },
                                        ],
                                        filled: !_vm.edit,
                                      },
                                      model: {
                                        value:
                                          _vm.config.use_inca_actions.mlops.url,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.config.use_inca_actions.mlops,
                                            "url",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "config.use_inca_actions.mlops.url",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v(_vm._s("Mulitorg"))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _vm.config.use_inca_actions
                                  ? _c(VCheckbox, {
                                      attrs: {
                                        readonly: !_vm.edit,
                                        disabled: !_vm.edit,
                                        dense: "",
                                        outlined: "",
                                        rules: [
                                          function (v) {
                                            return !!v || "Is required"
                                          },
                                        ],
                                        filled: !_vm.edit,
                                      },
                                      model: {
                                        value:
                                          _vm.config.use_inca_actions.mlops
                                            .multiorg,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.config.use_inca_actions.mlops,
                                            "multiorg",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "config.use_inca_actions.mlops.multiorg",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v(_vm._s("LLaves"))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _vm.config.use_inca_actions
                                  ? _c(VCombobox, {
                                      attrs: {
                                        multiple: "",
                                        dense: "",
                                        outlined: "",
                                        chips: "",
                                        "append-icon": "",
                                        disabled: !_vm.edit,
                                        filled: !_vm.edit,
                                      },
                                      on: {
                                        keydown: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "space",
                                              32,
                                              $event.key,
                                              [" ", "Spacebar"]
                                            )
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "selection",
                                            fn: function (ref) {
                                              var item = ref.item
                                              var attrs = ref.attrs
                                              var selected = ref.selected
                                              var disabled = ref.disabled
                                              var parent = ref.parent
                                              return [
                                                _c(
                                                  VChip,
                                                  _vm._b(
                                                    {
                                                      key: JSON.stringify(item),
                                                      attrs: {
                                                        "input-value": selected,
                                                        disabled: !_vm.edit,
                                                        dark: "",
                                                      },
                                                      on: {
                                                        "click:close":
                                                          function ($event) {
                                                            return parent.selectItem(
                                                              item
                                                            )
                                                          },
                                                      },
                                                    },
                                                    "v-chip",
                                                    attrs,
                                                    false
                                                  ),
                                                  [_vm._v(_vm._s(item))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3296037812
                                      ),
                                      model: {
                                        value:
                                          _vm.config.use_inca_actions.mlops
                                            .keys,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.config.use_inca_actions.mlops,
                                            "keys",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "config.use_inca_actions.mlops.keys",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(VCol, { attrs: { cols: "12" } }, [
                    _c(
                      "fieldset",
                      { staticClass: "fieldset" },
                      [
                        _c("legend", [
                          _vm._v(_vm._s("Reporte de acciones: Resumen")),
                        ]),
                        _c(
                          VRow,
                          { attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v(_vm._s("URL"))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _vm.config.use_inca_actions
                                  ? _c(VTextField, {
                                      attrs: {
                                        readonly: !_vm.edit,
                                        dense: "",
                                        outlined: "",
                                        rules: [
                                          function (v) {
                                            return !!v || "Is required"
                                          },
                                        ],
                                        filled: !_vm.edit,
                                      },
                                      model: {
                                        value:
                                          _vm.config.use_inca_actions.summary
                                            .url,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.config.use_inca_actions.summary,
                                            "url",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "config.use_inca_actions.summary.url",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v(_vm._s("Mulitorg"))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _vm.config.use_inca_actions
                                  ? _c(VCheckbox, {
                                      attrs: {
                                        readonly: !_vm.edit,
                                        disabled: !_vm.edit,
                                        dense: "",
                                        outlined: "",
                                        rules: [
                                          function (v) {
                                            return !!v || "Is required"
                                          },
                                        ],
                                        filled: !_vm.edit,
                                      },
                                      model: {
                                        value:
                                          _vm.config.use_inca_actions.summary
                                            .multiorg,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.config.use_inca_actions.summary,
                                            "multiorg",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "config.use_inca_actions.summary.multiorg",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v(_vm._s("LLaves"))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3" } },
                              [
                                _vm.config.use_inca_actions
                                  ? _c(VCombobox, {
                                      attrs: {
                                        multiple: "",
                                        dense: "",
                                        outlined: "",
                                        chips: "",
                                        "append-icon": "",
                                        disabled: !_vm.edit,
                                        filled: !_vm.edit,
                                      },
                                      on: {
                                        keydown: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "space",
                                              32,
                                              $event.key,
                                              [" ", "Spacebar"]
                                            )
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "selection",
                                            fn: function (ref) {
                                              var item = ref.item
                                              var attrs = ref.attrs
                                              var selected = ref.selected
                                              var disabled = ref.disabled
                                              var parent = ref.parent
                                              return [
                                                _c(
                                                  VChip,
                                                  _vm._b(
                                                    {
                                                      key: JSON.stringify(item),
                                                      attrs: {
                                                        "input-value": selected,
                                                        disabled: !_vm.edit,
                                                        dark: "",
                                                      },
                                                      on: {
                                                        "click:close":
                                                          function ($event) {
                                                            return parent.selectItem(
                                                              item
                                                            )
                                                          },
                                                      },
                                                    },
                                                    "v-chip",
                                                    attrs,
                                                    false
                                                  ),
                                                  [_vm._v(_vm._s(item))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3296037812
                                      ),
                                      model: {
                                        value:
                                          _vm.config.use_inca_actions.summary
                                            .keys,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.config.use_inca_actions.summary,
                                            "keys",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "config.use_inca_actions.summary.keys",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    VFlex,
                    {
                      staticClass: "text-center pt-3 mt-3",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        VBtn,
                        {
                          staticClass: "default mr-1",
                          attrs: { outlined: "" },
                          on: {
                            click: function ($event) {
                              _vm.edit = !_vm.edit
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.edit ? "Cancelar" : "Editar"))]
                      ),
                      _vm.edit
                        ? _c(
                            VBtn,
                            {
                              staticClass: "primary",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.onGuardar()
                                },
                              },
                            },
                            [_vm._v("Guardar")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("DialogConfirmationComponent", {
            ref: "MODAL_CONFIRM",
            attrs: {
              title: "Confirmación",
              text: "¿Está seguro de realizar los cambios?",
            },
            on: { onConfirm: _vm.onConfirmarGuardar },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }